/*
 * Copyright © 2021 Firecrest Clinical, Ltd.
 * All rights reserved.
 */

import {ApplicationRef, ComponentFactoryResolver, EmbeddedViewRef, Injectable, Injector, Type} from '@angular/core';

/**
 * Common utils for Angular.
 */
@Injectable({
    providedIn: 'root'
})
export class FcAgUtilsService {

    /**
     * Default constructor.
     */
    constructor() {
    }
    
    /**
     * Extend default config to current config.
     * 
     * @param config Current configuration.
     * @param defaultConfig Default configuration.
     */
    public extendConfig(config: any, defaultConfig: any) {
        if (typeof config === 'object' && typeof defaultConfig === 'object') {
            const keys = Object.keys(defaultConfig);
            for (let i = 0; i < keys.length; i++) {
                let key = keys[i];
                let src = defaultConfig[key];

                if (src && src.constructor === Object) {
                    if (typeof config[key] !== 'object') {
                        config[key] = {};
                    }
                    this.extendConfig(config[key], src);
                } else if (typeof config[key] === 'undefined') {
                    config[key] = src;
                }
            }
        }
    }

    /**
     * Create holder component for modal component.
     *
     * @param component Component.
     * @param resolver ComponentFactoryResolver.
     * @param applicationRef ApplicationRef.
     * @param injector Injector.
     * @returns HolderInstance.
     */
    public createHolderComponent<T>(component: Type<T>, resolver: ComponentFactoryResolver,
        applicationRef: ApplicationRef, injector: Injector): T {
        const componentFactory = resolver.resolveComponentFactory(component);

        const componentRef = componentFactory.create(injector);
        const componentRootNode = (componentRef.hostView as EmbeddedViewRef<any>)
            .rootNodes[0] as HTMLElement;

        applicationRef.attachView(componentRef.hostView);

        componentRef.onDestroy(() => {
            applicationRef.detachView(componentRef.hostView);
        });

        document.body.appendChild(componentRootNode);

        return componentRef.instance;
    }
}